import React from 'react';
import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

type Props = {
	isCodesDownloading: boolean;
	isAttendanceDownloading: boolean;
	isCodesGenerating: boolean;
	isJuryPairsLoading: boolean;
	onOpenCodesDialog: () => void;
	onGenerateCodesOnly: () => void;
	onOpenAttendanceDialog: () => void;
	onOpenJuryPairsDialog: () => void;
	onOpenDocumentAccessDialog: () => void;
};

const Stage3CodeActionsBar = ({
	isCodesDownloading,
	isAttendanceDownloading,
	isCodesGenerating,
	isJuryPairsLoading,
	onOpenCodesDialog,
	onGenerateCodesOnly,
	onOpenAttendanceDialog,
	onOpenJuryPairsDialog,
	onOpenDocumentAccessDialog,
}: Props) => (
	<Box
		sx={{
			mt: 2,
			display: 'flex',
			flexWrap: 'wrap',
			gap: 1,
			alignItems: 'center',
		}}
	>
		<Tooltip title='Pobiera etykiety kodów po opublikowaniu kwalifikacji do etapu III'>
			<span>
				<Button
					startIcon={isCodesDownloading ? <CircularProgress size={16} /> : <FileDownloadIcon />}
					variant={'outlined'}
					disabled={isCodesDownloading || isAttendanceDownloading || isCodesGenerating || isJuryPairsLoading}
					onClick={onOpenCodesDialog}
				>
					Etykiety kodów
				</Button>
			</span>
		</Tooltip>
		<Tooltip title='Generuje kody bez pobierania plików'>
			<span>
				<Button
					startIcon={isCodesGenerating ? <CircularProgress size={16} /> : <ReplayIcon />}
					variant={'outlined'}
					disabled={isCodesDownloading || isAttendanceDownloading || isCodesGenerating || isJuryPairsLoading}
					onClick={onGenerateCodesOnly}
				>
					Generuj kody
				</Button>
			</span>
		</Tooltip>
		<Tooltip title='Pobiera listę obecności z kodami prac dla etapu III'>
			<span>
				<Button
					startIcon={isAttendanceDownloading ? <CircularProgress size={16} /> : <FileDownloadIcon />}
					variant={'outlined'}
					disabled={isCodesDownloading || isAttendanceDownloading || isCodesGenerating || isJuryPairsLoading}
					onClick={onOpenAttendanceDialog}
				>
					Lista obecności
				</Button>
			</span>
		</Tooltip>
		<Tooltip title='Zarządzanie Etapem III'>
			<span>
				<Button
					startIcon={isJuryPairsLoading ? <CircularProgress size={16} /> : <ReplayIcon />}
					variant={'outlined'}
					disabled={isCodesDownloading || isAttendanceDownloading || isCodesGenerating || isJuryPairsLoading}
					onClick={onOpenJuryPairsDialog}
				>
					Zarządzanie III
				</Button>
			</span>
		</Tooltip>
		<Tooltip title='Udostępnianie sprawdzonych prac dla uczniów'>
			<span>
				<Button
					startIcon={isJuryPairsLoading ? <CircularProgress size={16} /> : <ReplayIcon />}
					variant={'outlined'}
					disabled={isCodesDownloading || isAttendanceDownloading || isCodesGenerating || isJuryPairsLoading}
					onClick={onOpenDocumentAccessDialog}
				>
					Udostępnianie prac
				</Button>
			</span>
		</Tooltip>
	</Box>
);

export default Stage3CodeActionsBar;
